import React, { useState, useEffect, Fragment } from 'react';
import moment from 'moment';
import CustomPagination from '../../../../../Components/Pagination/CustomPagination';
import { connect } from 'react-redux';
import { FormGroup, Input } from 'reactstrap';
import { groupBy } from '../../../../../../Utils/Utilities';

const CommentsOnPRoject = ({ comments, isProjectLevel, currentStore, accessLevel, filterOptions }) => {

    const [pageSize, setPageSize] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [filteredComments, setFilteredComments] = useState([]);
    const [filterValue, setFilterValue] = useState('')

    useEffect(() => {
        if (comments.length > 0) {
            setFilterValue('')
            setTotalRecords(comments.length)
            setFilteredComments(comments)
        }

    }, [comments, currentStore])

    const onPageChange = (pageEvent) => {
        setCurrentPage(pageEvent.currentPage);
        setPageSize(pageEvent.pageSize);
    }

    const getActiveClass = (accessLevelCommented) => {
        let className = '';
        if (accessLevel === accessLevelCommented)
            className = 'blue'
        return className;
    }

    const onFilterChange = (e) => {

        let evtValue = e.target.value;
        setFilterValue(evtValue);
        if (evtValue) {
            let filteredData = comments.filter(c => c.project_details_id == evtValue);
            setTotalRecords(filteredData.length)
            setFilteredComments(filteredData)
        }
        else {
            setTotalRecords(comments.length)
            setFilteredComments(comments)
        }

    }

    return (
        <div className=" my-3">
            <div className="row">
                <div className="col-md-8">
                    <h6>Comments {
                        (filteredComments && filteredComments.length) &&
                        <span>
                            <i className="far fa-comment" /> {filteredComments.length}
                        </span>
                    }

                    </h6>
                </div>
                <div className="col-md-4">
                    {
                        (filterOptions && filterOptions.length > 0) &&
                        <span className="float-right">
                            <FormGroup>
                                <Input type="select" name="filterSelect" id="filterSelect" value={filterValue} onChange={onFilterChange} >
                                    <option value="">Select</option>
                                    {
                                        Object.entries(groupBy(filterOptions, 'section')).map(([key, value], i) => {
                                            return <optgroup label={key} key={i}>
                                                {value.map((v, j) => <option key={j} value={v.id} >{v.fieldName}</option>)}
                                            </optgroup>

                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </span>
                    }
                </div>

            </div>
            <div className="d-flex row">
                <div className="col-md-12 bg-white mt-2 rounded box-shadow">
                    {filteredComments.
                        slice(
                            currentPage * pageSize,
                            (currentPage + 1) * pageSize
                        )
                        .map((comment, i) => {
                            return (
                                <div className="p-3 bg-white mt-2 rounded capitalize b-d-b b-r-0" key={i}>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex flex-row user">
                                            {
                                                comment.created_by.accessLevel === 3 &&
                                                <Fragment>
                                                    {
                                                        currentStore && currentStore.logo ? <img className="rounded-circle img-fluid img-responsive" src={currentStore.logo} width="40" />
                                                            : <img className="rounded-circle img-fluid img-responsive" src="/user.png" width="40" />
                                                    }
                                                </Fragment>
                                            }
                                            {
                                                comment.created_by.accessLevel === 0 &&
                                                <img className="rounded-circle img-fluid img-responsive" src="data:image/png;base64,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" width="40" />

                                            }

                                            <div className="d-flex flex-column ml-2"><span className={"font-weight-bold " + getActiveClass(comment.created_by.accessLevel)}>@{comment.created_by.accessLevel === 3 ? 'Customer' : comment.created_by.accessLevel === 0 ? 'Simpliworks' : ''}</span><span className="day">{moment(comment.created_date).fromNow()}</span></div>
                                        </div>
                                        {isProjectLevel && <div className="d-flex align-items-center px-3"><b><span className="badge fw-bolder px-4 py-3 font-small badge-light-blue">{comment.field_display_name}</span></b></div>}
                                    </div>
                                    <div className="comment-text text-justify mt-2">
                                        <p dangerouslySetInnerHTML={{ __html: comment.comments }}></p>
                                    </div>
                                </div>
                            )
                        })}
                    {
                        (filteredComments && filteredComments.length > 0) &&
                        <CustomPagination pageSize={pageSize} totalRecords={totalRecords} onPageChange={onPageChange} pageNums={[5, 10, 20, 50, 100]} />
                    }

                    {
                        filteredComments.length === 0 &&
                        <div className="font-italic p-3">
                            <span>No Comments Found</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

const mapToProps = (state) => {
    return {
        currentStore: state.project.currentStore,
        accessLevel: state.loggedUser.accessLevel
    }
}

export default connect(mapToProps)(CommentsOnPRoject);
